/* app/ui/nav/sticky */

define(
	'app/ui/nav/sticky',[
		'jquery',
		'pubsub'
	],
	function ($) {

		var classes;

		var $window;
		var $body;
		var $header;
		var $notification;
		var $subStickyNav;
		var $mobileSubNavBtn;

		var headerHeight;
		var headerTopHeight;

		var ignoreNextScroll = false;

		var didScroll;
		var lastScrollTop = 0;
		var delta = 5;
		var hasJumpNav = false;
		var stickyJumpNavHeight;
		var isMobileSubNavVisible = false;
		var subNavStickyHeight;
		var gap = 20;
		var mobileSubBtnHeight;

		var module = {
			init: function (selectors, classList) {
				$body = $('body');
				classes = classList;

				module._initElements(selectors);
				module._initSubscriptions();
				module._initEvents();

				module._adjustForTarget(true);

				module._setScrollListener();
				module._setStickiness();
			},

			_initElements: function (selectors) {
				$window = $(window);
				$header = $(selectors.header);
				$headerTop = $(selectors.headerTop);
				$notification = $(selectors.notification);
				$subStickyNav = $(".js-sub-navigation-wrap");
				$mobileSubNavBtn = $(".js-sticky-subnav-toggle");

				headerHeight = $header.outerHeight();
				headerTopHeight = $headerTop.outerHeight();
			},

			_initSubscriptions: function () {
				$.subscribe('/window/scroll', module._handleScroll);
			},

			_initEvents: function () {
				$(window).on('hashchange', module._hasSubStickyNav);
				$(window).on('hashchange', module._adjustForTarget);
				
			},

			_adjustForTarget: function (e) {
				var force = e === true;

				var $target = $(':target');
				var targetScrollTop;

				if (force) {
					ignoreNextScroll = true;
				}

				if ($target.length) {
					targetScrollTop = $target.offset().top;

					//if (targetScrollTop < lastScrollTop || force) {
						module._applyStickyOffset(force);
					//}
				}
			},

			_applyStickyOffset: function (force) {
				var $target = $(':target');

				var stickyHeaderHeight = $header.outerHeight();
				// check if Jamp nav is exit then include sticky sub nav height on offset value
				var offset = (hasJumpNav) ? (stickyHeaderHeight + subNavStickyHeight + gap) : stickyHeaderHeight;

				var scrollTop = $('body, html').scrollTop();
				var targetOffset = $target.offset().top;
				var newScrollTop = targetOffset - offset;

				//if (scrollTop === targetOffset) {
					// Ignore cases where a page was reloaded with
					// an active target and maintained its existing
					// scroll position
					$('html, body').scrollTop(newScrollTop);
				//}
				if (force) {
					lastScrollTop = scrollTop;
				}
			},

			_setScrollListener: function () {
				setInterval(
					function () {
						if (didScroll) {
							module._hasScrolled();
							didScroll = false;
						}
					},
					250
				);
			},

			_handleScroll: function () {
				module._setDidScroll();
				module._setStickiness();
				module._hasSubStickyNav();
			},

			_setDidScroll: function () {
				didScroll = true;
			},

			_setStickiness: function () {
				var notificationHeight;
				var scrollTop;

				var isSticky = $header.hasClass(classes.headerSticky);
				var shouldBeSticky;

				notificationHeight = $notification.outerHeight() || 1;
				scrollTop = $window.scrollTop();

				shouldBeSticky = scrollTop >= notificationHeight;

				stikyJumpNavHeight = $(".js-sub-navigation.is-sticky__subnav .js-subnav-menu").outerHeight() || 0;
				isMobileSubNavVisible = $(".js-sticky-subnav-toggle").is(":visible");

				if (isSticky !== shouldBeSticky) {
					if (shouldBeSticky) {
						$header.addClass(classes.headerSticky);
					} else {
						$header.removeClass(classes.headerSticky);
					}
				}
			},

			_hideHeader: function () {
				$header.removeClass(classes.headerDown).addClass(classes.headerUp);
			},

			_hasScrolled: function () {
				if (ignoreNextScroll) {
					ignoreNextScroll = false;
					return;
				}

				var scrollTop = $window.scrollTop();

				var notificationHeight = $notification.outerHeight() || 0;
				var headerTopScrollThreshold = headerTopHeight + notificationHeight;

				if (scrollTop > headerTopScrollThreshold) {
					$header.addClass(classes.headerHideTop);
				} else {
					$header.removeClass(classes.headerHideTop);
				}

				// Make sure they scroll more than delta
				if (Math.abs(lastScrollTop - scrollTop) <= delta || $body.hasClass(classes.dropdownOpen)) {
					return false;
				}

				// If they scrolled down and are past the navbar, add class .nav-up.
				// This is necessary so you never see what is "behind" the navbar.
				if (scrollTop > lastScrollTop && scrollTop > headerHeight) {
					// Scroll Down
					$header.addClass(classes.headerUp);
					$header.removeClass(classes.headerDown);
				} else {
					// Scroll Up
					if (scrollTop + $window.height() < $(document).height()) {

						if (scrollTop > headerHeight) {
							$header.addClass(classes.headerDown);
						} else {
							$header.removeClass(classes.headerDown);
						}

						$header.removeClass(classes.headerUp);
					}
				}

				lastScrollTop = scrollTop;
			},

			_hasSubStickyNav: function () {
				
			
				if ($subStickyNav.length == 0) {
					hasJumpNav = false;
					return;
				}

				hasJumpNav = true;
				mobileSubBtnHeight = $mobileSubNavBtn.outerHeight();

				// if Jump Nav exit on the page update skticy JumpNav height otherwise use default value : 68
				if (isMobileSubNavVisible) {
					subNavStickyHeight = (isMobileSubNavVisible) ? ((mobileSubBtnHeight && 0 < mobileSubBtnHeight) ? mobileSubBtnHeight : 68) : 68;
				} else {
					subNavStickyHeight = (stickyJumpNavHeight) ? stickyJumpNavHeight : 68;
                }
            }
		};

		return {
			init: module.init
		};
	}
);
